import React from "react";
import Home from "../Home";
import Section from "../Layout2/Section";

const Layout2 = () => {
  document.title = "Home | StarMarket";
  return (
    <React.Fragment>
      <Home />
    </React.Fragment>
  );
};
export default Layout2;
